import { ReactNode } from 'react'
import styled from 'styled-components'

import useFeatureFlag from 'hooks/useFeatureFlag'
import { googleAuthentication } from 'featureFlags'

import AuthToken from './AuthToken'
import GoogleIcon from '../../icons/GoogleIcon'
import { LoginSocial } from '../styles'

const GoogleSignInButton = styled(LoginSocial)`
  color: #444444;
  border: 1px solid #888888;
  margin-bottom: 10px;
`

type GoogleLoginProps = {
  children: ReactNode
}

const GoogleLogin = ({ children }: GoogleLoginProps) => {
  const googleAuthenticationEnabled = useFeatureFlag(googleAuthentication)

  if (!googleAuthenticationEnabled) {
    return null
  }

  return (
    <form action="/omniauth/google" method="post">
      <AuthToken />
      <GoogleSignInButton type="submit" className="qa-google-login">
        <GoogleIcon />
        {children}
      </GoogleSignInButton>
    </form>
  )
}

export default GoogleLogin
